<template>

    <kt-modal
        :visible="recordVisible"
        :title="recordTitle"
        @dismiss="onDismiss()"
    >
        <template #body>
            <tech-form 
                v-model="record"
            ></tech-form>
        </template>
    
        <template #footer>
            <div class="kt-modal-actions">
                <button @click="onDismiss()" class="btn btn-outline-secondary">
                    <X :size="16" class="me-1" />Close
                </button>
                <button v-if="record.Id" @click="deleteRecord()" class="btn btn-outline-danger">
                    <Trash2 :size="16" class="me-1" />Delete
                </button>
                <button @click="saveRecord()" class="btn btn-primary">
                    <Save :size="16" class="me-1" />Save
                </button>
            </div>
        </template>
    </kt-modal>
        
    </template>
    
    <script lang="ts" setup>
    
    import { ref, onMounted, onUpdated, watch } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import Api from "@/services/ApiService";
    import TechForm from "@/components/Techs/TechForm.vue";
    import { TechnicianModel } from "@/models/TechnicianModel";
    import KtModal from "@/components/UI/KtModal.vue";
    import Alert from "@/services/Alert";
    import { useTechStore } from "@/stores/TechStore";
    import { Save, X, Trash2 } from 'lucide-vue-next';
    
    const route = useRoute();
    const router = useRouter();
    const recordTitle = ref("Tech Entry");
    const recordVisible = ref(true);
    
    const props = defineProps({
        id: {
            type: [Number, String],
            default: null
        }
    });
    
    const emit = defineEmits(["cancel", "saved"]);
    
    const newRecord = () =>
    {
        return new TechnicianModel();
    };
    
    const record = ref(newRecord());
    
    const saveRecord = async () =>
    {
        if (!record.value.TechnicianName)
        {
            Alert.notify({
                text:"Please enter a technician name"
            });
            return;
        }

        if (!record.value.Email)
        {
            Alert.notify({
                text: "Please enter an email address"
            });
            return;
        }

        try {
            let pay = record.value;
            await Api.saveTech(pay);

            let techs = useTechStore();
            await techs.reload();

            // If used as global modal, emit event; otherwise navigate
            if (props.id !== null) {
                emit("saved");
            } else {
                router.back();
            }
        } catch (error) {
            console.error("Save failed:", error);
        }
    };
    
    const deleteRecord = async () =>
    {
        Alert.notify({
            text: "Deletion is currently disabled"
        });
    };
    
    
    const onDismiss = () =>
    {
        // If used as global modal, emit event; otherwise navigate
        if (props.id !== null) {
            emit("cancel");
        } else {
            router.back();
        }
    };

    const loadRecord = async (idValue?: string | number | null) =>
    {
        if (idValue && idValue !== "new") {
            let rec = await Api.loadTech(Number(idValue));
            record.value = rec;
        } else {
            record.value = newRecord();
        }
    };

    
    /*
    onUpdated(async () =>
    {
        loadRecord();
    });
    */

    onMounted(() =>
    {
        // Use prop id if provided, otherwise use route params
        let idToLoad = props.id !== null ? props.id : route.params.id;
        // Handle case where route.params.id might be an array
        if (Array.isArray(idToLoad)) {
            idToLoad = idToLoad[0];
        }
        loadRecord(idToLoad);
    });
    
    // Watch for prop changes when used as global modal
    watch(() => props.id, async (newId) => {
        if (newId !== null) {
            await loadRecord(newId);
        }
    });
    
</script>